<div class="cpcontent">
    <h2>Modal Test</h2>
    <button class="btn btn-primary" (click)="showModal = true">Open Modal Window</button>
    <div *ngIf="showModal" #testmodal class="cpmodal">
        <div class="cpmodal-content">
            <h5>This is a modal</h5>
            The main css for the classes is in styles.css<br>
            Note: The css has changed locally to adjust the width to 50%
            <br>
            <button class="btn btn-primary" (click)="showModal = false">Close Modal</button>
        </div>
    </div>


    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
    Here is just text to fill the page<br>
</div>